<main class="main">
  <div class="page-header text-center" style="background-image: url(assets/images/aboutus-new.jpg)">
    <div class="container">
      <h1 class="page-title">Cannabis Delivery in Bronx, NY</h1>
    </div>
  </div>


  <div class="container">
    <div class="DataPart">
      <div class="row align-items-center mt-5">
        <div class="col-8">
          <div class="heading-main">
            <h2 class="title-lg" tabindex="0">Edibles</h2>
            <p class="headeig_home_sub" tabindex="0" role="text">Gummies, Chocolates, and More. Yum!</p>
          </div>
        </div>
        <div class="col-4">
          <div class="view-more-link cursor">
            <a [ngStyle]="getColor('text')" tabindex="0" [routerLink]="['/shop/Edibles_edibles']">View More</a>
          </div>
        </div>
      </div>
      <div>
        <app-product-listing [payLoad]="payload"></app-product-listing>
      </div>
    </div>
  </div>


  <div class="contactPage">
    <div class="container">
      <div class="DataPart">
        <div class="row align-items-center">
          <div class="col-md-6">
            <figure>
              <img src="assets/images/Delivery_in_Mamaroneck.png" alt="Cannabis Delivery in Bronx, NY">
            </figure>
          </div>
          <div class="col-md-6">
            <h2>Cannabis Delivery in Bronx, NY</h2>
            <p>Finding good cannabis in Bronx shouldn't be hard it should be easily accessible from anywhere. Bronx is
              famous for its
              energy & culture people wants cannabis that matches the vibe feels authentic, safe, and easy to get.
              That's exactly what
              Highlife Health delivers.</p>
            <p>We stock only the finest cannabis strains and products, each selected for purity, potency, and
              consistency. If you want
              freshly cured flower, tasty edibles, smooth vape cartridges, strong concentrates, or perfectly rolled
              pre-rolls, then
              you will find your choice here.</p>
            <p>From discreet packaging to timely delivery to the customer-first approach. Highlife Health ensures your
              experience of
              premium cannabis should never be complicated.</p>
          </div>
        </div>
      </div>
    </div>
  </div>



  <div class="catName pt-0">
    <div class="container">
      <div class="catList">
        <ul>
          <li style="cursor: pointer;" (click)="routeMeTo('shop/Flower_flower')"><img
              src="https://cova-common.s3.ca-central-1.amazonaws.com/flower-c.png" alt="Flower"><span>Flower</span></li>
          <li style="cursor: pointer;" (click)="routeMeTo('shop/Vapes_vaporizers')"><img
              src="https://cova-common.s3.ca-central-1.amazonaws.com/Vapes-c.png" alt="Vapes"><span>Vapes</span></li>
          <li style="cursor: pointer;" (click)="routeMeTo('shop/Edibles_edibles')"><img
              src="https://cova-common.s3.ca-central-1.amazonaws.com/edibles-c.png" alt="Edibles"><span>Edibles</span>
          </li>
          <li style="cursor: pointer;" (click)="routeMeTo('shop/Pre roll_pre-rolls')"><img
              src="https://cova-common.s3.ca-central-1.amazonaws.com/Pre-roll-c.png" alt="Pre Rolls"><span>Pre
              Rolls</span></li>
          <li style="cursor: pointer;" (click)="routeMeTo('shop/Concentrates_concentrates')"><img
              src="https://cova-common.s3.ca-central-1.amazonaws.com/Concentrates-c.png"
              alt="Concentrates"><span>Concentrates</span></li>
          <li style="cursor: pointer;" (click)="routeMeTo('shop/Tinctures_tinctures')"><img
              src="https://cova-common.s3.ca-central-1.amazonaws.com/tincture-c.png"
              alt="Tinctures"><span>Tinctures</span></li>
          <li style="cursor: pointer;" (click)="routeMeTo('shop/Topical_topical')"><img
              src="https://cova-common.s3.ca-central-1.amazonaws.com/topical-c.png" alt="Topical"><span>Topical</span>
          </li>
          <li style="cursor: pointer;" (click)="routeMeTo('shop/Accessories_accessories')"><img
              src="https://cova-common.s3.ca-central-1.amazonaws.com/Accessories-c.png"
              alt="Accessories"><span>Accessories</span></li>
        </ul>
      </div>
    </div>
  </div>


  <div class="contactPage pt-3">
    <div class="container">
      <div class="DataPart">
        <div class="row ">
          <div class="col-md-6">
            <h2>Why Bronx Residents Choose Us</h2>
            <div class="row">
              <div class="col-md-6">
                <div class="boxes-four">
                  <h4>Licensed & Compliant</h4>
                  <p>Fully licensed and regulated under New York State.</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="boxes-four">
                  <h4>Large Product Range</h4>
                  <p>Flower, pre-rolls, edibles, concentrates, and vape cartridges.</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="boxes-four">
                  <h4>Safe & Discreet Delivery</h4>
                  <p>Depending on the area of delivery, it's shipped all the way to the door.</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="boxes-four">
                  <h4>Clear Transparency</h4>
                  <p>Shop for your products online through images, descriptions, and prices.</p>
                </div>
              </div>
              <div class="col-md-12">
                <div class="boxes-four">
                  <h4>Affordable Deals</h4>
                  <p>An ever-changing set of promotions aimed at keeping cannabis medicine affordable.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <h2>Products We Offer</h2>
            <div class="row">
              <div class="col-md-6">
                <div class="boxes-four">
                  <h4>Flower & Pre-rolls</h4>
                  <p>Lab-tested, consistent, and high-quality strains.</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="boxes-four">
                  <h4>Edibles</h4>
                  <p>Measured-dose, delicious-flavor, fully-compliant.</p>
                </div>
              </div>
              <div class="col-md-12">
                <div class="boxes-four">
                  <h4>Concentrates & Cartridges</h4>
                  <p>Potent, reliable, and safe. </p>
                </div>
              </div>
              <div class="col-md-12">
                <div class="boxes-four mt-3">
                  <p><b>All products are sourced from licensed New York growers and tested for safety.</b></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="contactPage bgimg" style="background: url(assets/images/weedbg.jpg);">
    <div class="container">
      <div class="DataPart">
        <div class="row">
          <div class="col-md-6 mb-2">
            <div class="boxes-four">
              <h4 class="mb-1">How Delivery Works</h4>
              <p class="mb-2">At Highlife Health, delivering your cannabis products is made simple secure, and
                stress-free.
                First things first, check if you are eligible for delivery by typing in your Bronx address on our
                Delivery Area page. Once you have it confirmed, freely browse our exhaustive and premium catalog for
                flower, edibles, vape carts, concentrates, and pre-rolls-all from licensed providers. Pick out your
                favorites, place an order, and pay securely using our pay-by-bank option. After that, the company takes
                over to make sure to ship your goods safely, discreetly, and on time right to your doorstep. If your
                Bronx address is yet not part of the delivery range, never worry. Keep checking, as we constantly expand
                our delivery networks to spread the joy to more locations all across the city.</p>
            </div>
          </div>
          <div class="col-md-6 mb-2">
            <div class="boxes-four">
              <h4 class="mb-1">Compliance & Transparency</h4>
              <p>At Highlife Health, compliance and transparency are at the very core of what we do. As a woman-owned,
                family-run dispensary, we pride ourselves in working fully within New York State law and holding the
                highest standards of integrity. Every product we offer is sourced from licensed growers, undergoes
                lab-testing for safety, purity, and reliability. From cultivation through delivery, transparency, and
                trust remain constant guiding principles, so that you will be able to trust every ounce of quality and
                authenticity in our cannabis products.</p>
            </div>
          </div>
          <div class="col-md-12 mb-2">
            <div class="boxes-four">
              <h4 class="mb-1">Get Started Today </h4>
              <p>Highlife Health offers easy access to safe and dependable cannabis in the Bronx. If you are searching
                for a "cannabis dispensary Bronx NY" or "cannabis delivery Bronx NY," we simply offer a straightforward,
                legal, and convenient choice.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="faqSection pt-0">
    <div class="container">
      <h2>FAQ's</h2>
      <div class="row justify-content-center">
        <div class="col-md-10">
          <div class="faqsPart">
            <h4>Q: Are your products legal?</h4>
            <p>A: Yes, all products are licensed, tested, and compliant with NY State regulations.</p>
          </div>
          <div class="faqsPart">
            <h4>Q: What products do you offer?</h4>
            <p>A: Flower, pre-rolls, edibles, concentrates, and vape cartridges.</p>
          </div>
          <div class="faqsPart">
            <h4>Q: How can I pay for delivery?</h4>
            <p>A: Secure pay-by-bank options are available for all delivery orders.</p>
          </div>
          <div class="faqsPart">
            <h4>Q: Do you offer discounts?</h4>
            <p>A: Yes - visit our “Deals” page to see current promotions.</p>
          </div>
        </div>
      </div>



      <div class="abtclas pt-3">
        <h3><b>Fast Cannabis & Vape Delivery in These Areas</b></h3>
        <p>We proudly deliver high-quality cannabis, vapes, edibles, and pre-rolls across multiple NY locations. Check
          out our
          nearby service areas below.</p>

        <div class="weed-location-grid">

          <div class="location-box">
            <a routerLink="/Cannabis_Delivery_Larchmont_NY">
              <h4>Larchmont NY</h4>
              <p>Cannabis Delivery</p>
            </a>
          </div>
          <div class="location-box">
            <a routerLink="/Disposable_Vapes_Larchmont_NY">
              <h4>Larchmont NY</h4>
              <p>Vape Delivery</p>
            </a>

          </div>

          <div class="location-box">
            <a routerLink="/Buy_Weed_Online_in_Rye">
              <h4>Rye NY</h4>
              <p>Weed Delivery</p>
            </a>

          </div>


          <div class="location-box">
            <a routerLink="/Buy_Edibles_Online_Rye">
              <h4>Rye NY</h4>
              <p>Edibles Delivery</p>
            </a>

          </div>

          <div class="location-box">
            <a routerLink="/Buy_Pre_Rolls_Online_in_Rye_NY">
              <h4>Rye NY</h4>
              <p>Pre Rolls Delivery</p>
            </a>

          </div>

          <div class="location-box">
            <a routerLink="/Cannabis_Delivery_Mamaroneck_NY">
              <h4>Mamaroneck NY</h4>
              <p>Cannabis Delivery</p>
            </a>
          </div>

          <div class="location-box">
            <a routerLink="/Vape_Pen_Cartridges_Mamaroneck_NY">
              <h4>Mamaroneck NY</h4>
              <p>Vape Delivery</p>
            </a>
          </div>
          <div class="location-box">
            <a routerLink="/Weed_Delivery_Mamaroneck_NY">
              <h4>Mamaroneck NY</h4>
              <p>Weed Delivery</p>
            </a>
          </div>
          <div class="location-box">
            <a routerLink="/Cannabis_Delivery_bronx_NY">
              <h4>Bronx NY</h4>
              <p>Cannabis Delivery</p>
            </a>
          </div>
          <div class="location-box">
            <a routerLink="/Weed_Delivery_Bronx_NY">
              <h4>Bronx NY</h4>
              <p>Weed Delivery</p>
            </a>
          </div>
          <div class="location-box">
            <a routerLink="/Vape_Pen_Cartridges_Bronx_NY">
              <h4>Bronx NY</h4>
              <p>Vape Delivery</p>
            </a>
          </div>
          <div class="location-box">
            <a routerLink="/THC_Drinks_in_Bronx">
              <h4>Bronx NY</h4>
              <p>THC Drinks</p>
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>


</main>